import {
    HeadingGroup,
    ModalLayout,
    Pagination,
    SearchFilters,
    Table,
  } from "@wac-ui-dashboard/wac_component_library";
  import React from "react";
  import { FaSort } from "react-icons/fa";
  import OrderColumn from "../../Global/OrderColumn";
  import EmptyData from "../../Global/EmptyData";
  import SendExcelData from "../../Admin/OrderList/SendExcelData";
  import CustomDateRangePicker from "../../Global/CustomDateRangePicker"
  import Select from "react-select";
  import useQubriuxOffer from "./useQubriuxOffer";
  
  const QubriuxOffer = () => {
    const {
      date,
      storeListObj,
      rewardsListObj,
      isLoading,
      storeList,
      rewardsList,
      isFetching,
      showEditModal,
      isExcelLinkSend,
      paginationOptions,
      qubriuxOfferList,
      qubriuxOfferState,
      handleUserFeedbackExcelDownload,
      updateUserFeedbackFields,
      handleEditColumnsClick,
      handleDateRangeChange,
      handleDateChange,
      handlePagination,
      handleClearClick,
      handlePageSize,
      handleSearch,
      sendExcelData,
      handleChangeStore,
      handleChangeReward,
      handleSort,
      modalClose,
      refetch,
      getRow,
    } = useQubriuxOffer();

    return (
      <>
        <HeadingGroup title="Qubriux Offer"className={`pro-mb-4`}>
          <div className="col dropdown-filter pro-d-flex">
            <button
              className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
              type="submit"
              onClick={handleUserFeedbackExcelDownload}
            >
              <span className="material-symbols-outlined x4">download</span>
              <span>{`Export Data`}</span>
            </button>
          </div>
        </HeadingGroup>
        <div className="col-auto pro-pt-3 pro-pb-6">
          <SearchFilters
            onSearchInput={handleSearch}
            loading={isLoading}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            handleClear={handleClearClick}
            searchInputProps={{ value: qubriuxOfferState?.search }}
            handleActionClick={handleEditColumnsClick}
            searchable={true}
            dropDownFilter={
              <>
                <div className="col-auto">
                  <CustomDateRangePicker
                    defaultDateRange={date}
                    handleDateRangeChange={handleDateRangeChange}
                  />
                </div>
                <div className="col-auto dropdown-filter">
                  <Select
                    value={storeListObj}
                    onChange={handleChangeStore}
                    options={storeList}
                    placeholder="Select Store"
                    classNamePrefix={`pro-input`}
                    className={`pro-input lg search-filter-select`}
                    isClearable
                  />
                </div>
                <div className="col-auto dropdown-filter">
                  <Select
                    value={rewardsListObj}
                    onChange={handleChangeReward}
                    options={rewardsList}
                    placeholder="Select Reward"
                    classNamePrefix={`pro-input`}
                    className={`pro-input lg search-filter-select`}
                    isClearable
                    isMulti
                  />
                </div>
              </>
            }
            onDateChange={handleDateChange}
            initialDateRange={date}
          />
          {qubriuxOfferList?.data?.result?.length === 0 ? (
            <EmptyData />
          ) : (
            <Table
              multiSelect={false}
              data={qubriuxOfferList?.data?.result || []}
              uniqueID={"id"}
              fields={qubriuxOfferList?.data?.fields || []}
              SortIcon={<FaSort />}
              editIcon={<span className="material-symbols-outlined">edit</span>}
              handleSort={handleSort}
              getRow={getRow}
              loading={isFetching}
              clear={qubriuxOfferState?.clearSelection}
              perpage={qubriuxOfferState?.currentPageSize}
              assignable={false}
              deletable={false}
              editable={false}
              showCheckBox={false}
            />
          )}
  
          {qubriuxOfferList?.data?.result?.length > 0 && (
            <Pagination
              currentPage={qubriuxOfferState?.currentPage}
              totalPageCount={Math.ceil(
                qubriuxOfferState?.totalCount /
                qubriuxOfferState?.currentPageSize
              )}
              defaultValue={paginationOptions?.filter(
                (item) => item?.value === qubriuxOfferState?.currentPageSize
              )}
              onPageChange={handlePagination}
              options={paginationOptions}
              onActionChange={handlePageSize}
              center
            />
          )}
          <ModalLayout
            show={showEditModal}
            handleClose={handleEditColumnsClick}
            backdrop="static"
          >
            <div className="pro-m-5">
              <OrderColumn
                title={"Choose which columns you see"}
                refetchData={refetch}
                tableFields={qubriuxOfferList?.data?.fields || []}
                moduleId={qubriuxOfferList?.data?.module_id}
                updateData={updateUserFeedbackFields}
              />
            </div>
          </ModalLayout>
          <ModalLayout
            show={qubriuxOfferState.CardOfferExcelSendModal}
            handleClose={handleUserFeedbackExcelDownload}
            title={`Send Excel Download Link`}
            backdrop="static"
          >
            <div className="pro-m-5">
              <SendExcelData
                isBestSeller
                handleCloseModal={modalClose}
                sendExcelData={sendExcelData}
                isExcelLinkSend={isExcelLinkSend}
              />
            </div>
          </ModalLayout>
        </div>
      </>
    );
  };
  
  export default QubriuxOffer;
  